import React from "react";
import ReactLoading from "react-loading";
import "./Button.scss";

function Button(props) {
  const { loading, text, onClick, className, style, ...rest } = { ...props };

  return (
    <button
      onClick={onClick}
      className={`my-button ${className ?? ""}`}
      style={style}
      {...rest}
    >
      {loading ? (
        <ReactLoading type={"balls"} color={"white"} height={30} width={30} />
      ) : (
        text
      )}
    </button>
  );
}

export default Button;
